export const updateCustomerBacklightPreferences = /* GraphQL */ `
  mutation UpdateCustomerBacklightPreferences(
    $customerId: ID!
    $preferences: BacklightPreferencesInput!
  ) {
    updateCustomerBacklightPreferences(customerId: $customerId, preferences: $preferences) {
      id
      name
      email
      backlightPreferences {
        color {
          r
          g
          b
        }
        pattern
      }
    }
  }
`;

export const createHub = /* GraphQL */ `
  mutation CreateHub($input: CreateHubInput!) {
    createHub(input: $input) {
      id
      serialNumber
      macAddress
      name
      status
      latitude
      longitude
      config
      hubType
      parentHubId
      installedAt
      installedBy
      installedByName
    }
  }
`;

export const updateHub = /* GraphQL */ `
  mutation UpdateHub($input: UpdateHubInput!) {
    updateHub(input: $input) {
      id
      serialNumber
      macAddress
      name
      status
      latitude
      longitude
      config
      hubType
      parentHubId
      installedAt
      installedBy
      installedByName
    }
  }
`;

export const updateHubAddress = /* GraphQL */ `
  mutation UpdateHubAddress($input: UpdateHubAddressInput!) {
    updateHubAddress(input: $input) {
      id
      serialNumber
      macAddress
      name
      status
      latitude
      longitude
      street
      city
      state
      zip
      date
      time
      timezone
      hubType
      parentHubId
      installedAt
      installedBy
      installedByName
    }
  }
`;

export const updateHubConfig = /* GraphQL */ `
  mutation UpdateHubConfig($id: ID!, $config: String!) {
    updateHubConfig(id: $id, config: $config) {
      id
      serialNumber
      macAddress
      name
      status
      latitude
      longitude
      config
      hubType
      parentHubId
      installedAt
      installedBy
      installedByName
    }
  }
`;

export const deleteHub = /* GraphQL */ `
  mutation DeleteHub($id: ID!) {
    deleteHub(id: $id) {
      id
      serialNumber
      macAddress
      name
      status
      latitude
      longitude
      config
      hubType
      parentHubId
      installedAt
      installedBy
      installedByName
    }
  }
`;

export const associateHub = /* GraphQL */ `
  mutation AssociateHub($hubId: ID!, $hubName: String) {
    associateHub(hubId: $hubId, hubName: $hubName)
  }
`;

export const associateHubCustomer = /* GraphQL */ `
  mutation AssociateHubCustomer($hubId: ID!, $userId: ID!, $customerId: ID!) {
    associateHubCustomer(hubId: $hubId, userId: $userId, customerId: $customerId)
  }
`;

export const dissociateHubCustomer = /* GraphQL */ `
  mutation DissociateHubCustomer($hubId: ID!, $customerId: ID!) {
    dissociateHubCustomer(hubId: $hubId, customerId: $customerId)
  }
`;

export const linkGateway = /* GraphQL */ `
  mutation LinkGateway($gatewayHubId: ID!, $parentHubId: ID!) {
    linkGateway(gatewayHubId: $gatewayHubId, parentHubId: $parentHubId)
  }
`;

export const unlinkGateway = /* GraphQL */ `
  mutation UnlinkGateway($gatewayHubId: ID!) {
    unlinkGateway(gatewayHubId: $gatewayHubId)
  }
`;

export const createSensor = /* GraphQL */ `
  mutation CreateSensor($input: CreateSensorInput!) {
    createSensor(input: $input) {
      id
      hubId
      serialNumber
      type
      name
      location
      sublocation
      status
      lastReported
      nodeId
      unid
      otaStatus
      otaProgress
      otaTargetVersion
      otaError
      otaUpdatedAt
      rssi
      rssiUpdatedAt
      installCompletedAt
      installCompletedBy
      installCompletedByName
    }
  }
`;

export const createSensorLink = /* GraphQL */ `
  mutation CreateSensorLink($input: CreateSensorLinkInput!) {
    createSensorLink(input: $input) {
      id
      hubId
      serialNumber
      type
      name
      location
      sublocation
      status
      lastReported
      nodeId
      unid
      otaStatus
      otaProgress
      otaTargetVersion
      otaError
      otaUpdatedAt
      rssi
      rssiUpdatedAt
      installCompletedAt
      installCompletedBy
      installCompletedByName
    }
  }
`;

export const createSensorGroup = /* GraphQL */ `
  mutation CreateSensorGroup($input: CreateSensorGroupInput!) {
    createSensorGroup(input: $input) {
      id
      hubId
      serialNumber
      type
      name
      location
      sublocation
      status
      lastReported
      nodeId
      unid
      otaStatus
      otaProgress
      otaTargetVersion
      otaError
      otaUpdatedAt
      rssi
      rssiUpdatedAt
      installCompletedAt
      installCompletedBy
      installCompletedByName
      groupId
      sensorGroupConfiguration {
        indoor
        metadata
      }
    }
  }
`;

export const updateSensor = /* GraphQL */ `
  mutation UpdateSensor($input: UpdateSensorInput!) {
    updateSensor(input: $input) {
      id
      hubId
      serialNumber
      type
      version
      name
      location
      sublocation
      status
      lastReported
      nodeId
      unid
      otaStatus
      otaProgress
      otaTargetVersion
      otaError
      otaUpdatedAt
      rssi
      rssiUpdatedAt
      installCompletedAt
      installCompletedBy
      installCompletedByName
      branchCircuits {
        circuitNumber
        breakerNumber
        powerMonitorInputNumber
        breakerType
        breakerAmperage
        voltage
        location
        sublocation
        underCurrentAlert
        overCurrentAlert
        underCurrentAlertCustomAmps
        overCurrentAlertCustomAmps
      }
      equipmentDetails {
        type
        systemAge
        manufacturingDate
        manufacturer
        brand
        model
        serialNumber
        warrantyDuration
        notes
        systemType
        equipmentTonnage
        airFilterConfiguration {
          manufacturer
          modelNumber
          mervRated
          mervRating
          filterSizeHeight
          filterSizeWidth
          filterSizeDepth
          filterMaterial
          systemType
        }
        pressureConfiguration {
          staticPressureTarget
          supplyStaticPressure
          returnStaticPressure
          filterPressureDrop
          triggerAlertOnPressure
        }
        plenumConfiguration {
          shape
          widthInches
          heightInches
          diameterInches
          knownCFM
          airflowCalibrationFactor
        }
        photos {
          url
        }
        isVariableSpeed
        systemVoltage
        compressorRLA
        compressorLRA
      }
      targetStaticPressure
      startingStaticPressure
      replacementDeltaInH2O
      pendingBaselineCapture
      baselineCapturedAt
      baselineCTAmps
      removal {
        reason
        requestedAt
        receivedAt
        result
        trigger
        closedAt
      }
      heldForRemovalOf
    }
  }
`;

export const updateHubEnergyRate = /* GraphQL */ `
  mutation UpdateHubEnergyRate($input: UpdateHubEnergyRateInput!) {
    updateHubEnergyRate(input: $input) {
      id
      config
    }
  }
`;

// Selects everything onSensorUpdated asks for: it is in that subscription's
// @aws_subscribe list, and AppSync drops the event for every subscriber when
// the mutation selects less (subset rule, see sensorStreamHandler).
export const updateSensorBranchCircuits = /* GraphQL */ `
  mutation UpdateSensorBranchCircuits($input: UpdateSensorBranchCircuitsInput!) {
    updateSensorBranchCircuits(input: $input) {
      id
      hubId
      serialNumber
      type
      version
      name
      location
      sublocation
      status
      lastReported
      nodeId
      unid
      otaStatus
      otaProgress
      otaTargetVersion
      otaError
      otaUpdatedAt
      rssi
      rssiUpdatedAt
      installCompletedAt
      installCompletedBy
      installCompletedByName
      branchCircuits {
        circuitNumber
        breakerNumber
        powerMonitorInputNumber
        breakerType
        breakerAmperage
        voltage
        location
        sublocation
        underCurrentAlert
        overCurrentAlert
        underCurrentAlertCustomAmps
        overCurrentAlertCustomAmps
      }
      equipmentDetails {
        type
        systemAge
        manufacturingDate
        manufacturer
        brand
        model
        serialNumber
        warrantyDuration
        notes
        systemType
        equipmentTonnage
        airFilterConfiguration {
          manufacturer
          modelNumber
          mervRated
          mervRating
          filterSizeHeight
          filterSizeWidth
          filterSizeDepth
          filterMaterial
          systemType
        }
        pressureConfiguration {
          staticPressureTarget
          supplyStaticPressure
          returnStaticPressure
          filterPressureDrop
          triggerAlertOnPressure
        }
        plenumConfiguration {
          shape
          widthInches
          heightInches
          diameterInches
          knownCFM
          airflowCalibrationFactor
        }
        photos {
          url
        }
        isVariableSpeed
        systemVoltage
        compressorRLA
        compressorLRA
      }
      targetStaticPressure
      startingStaticPressure
      replacementDeltaInH2O
      pendingBaselineCapture
      baselineCapturedAt
      baselineCTAmps
      removal {
        reason
        requestedAt
        receivedAt
        result
        trigger
        closedAt
      }
      heldForRemovalOf
    }
  }
`;

export const deleteSensorLink = /* GraphQL */ `
  mutation DeleteSensorLink($input: DeleteSensorLinkInput!) {
    deleteSensorLink(input: $input) {
      id
      hubId
      serialNumber
      type
      name
      location
      sublocation
      status
      lastReported
      nodeId
      unid
      otaStatus
      otaProgress
      otaTargetVersion
      otaError
      otaUpdatedAt
      rssi
      rssiUpdatedAt
      installCompletedAt
      installCompletedBy
      installCompletedByName
      groupId
      sensorGroupConfiguration {
        indoor
        metadata
      }
    }
  }
`;

// unitState: what the installer says the unit is (ALIVE needs the SW2 reset,
// step 2). Omitted = no reason: the base station removes the node on its own,
// and the cloud treats it as not BROKEN. Returns the row with the removal it
// opened.
export const deleteSensor = /* GraphQL */ `
  mutation DeleteSensor($id: ID!, $unitState: SensorUnitState) {
    deleteSensor(id: $id, unitState: $unitState) {
      id
      hubId
      serialNumber
      type
      name
      location
      sublocation
      status
      lastReported
      nodeId
      unid
      otaStatus
      otaProgress
      otaTargetVersion
      otaError
      otaUpdatedAt
      rssi
      rssiUpdatedAt
      installCompletedAt
      installCompletedBy
      installCompletedByName
      removal {
        reason
        requestedAt
        receivedAt
        result
        trigger
        closedAt
      }
      heldForRemovalOf
    }
  }
`;

// The installer's "I did the reset" (no unitState) or "Switch to broken"
// (unitState: BROKEN) on a deleted row whose removal is still open.
export const retrySensorRemoval = /* GraphQL */ `
  mutation RetrySensorRemoval($id: ID!, $unitState: SensorUnitState) {
    retrySensorRemoval(id: $id, unitState: $unitState) {
      id
      hubId
      status
      removal {
        reason
        requestedAt
        receivedAt
        result
        trigger
        closedAt
      }
      heldForRemovalOf
    }
  }
`;

export const retrySensorInclusion = /* GraphQL */ `
  mutation RetrySensorInclusion($sensorId: ID!) {
    retrySensorInclusion(sensorId: $sensorId)
  }
`;

// Blinks a paired sensor's LEDs. true = command sent, not that it blinked.
export const identifySensor = /* GraphQL */ `
  mutation IdentifySensor($sensorId: ID!) {
    identifySensor(sensorId: $sensorId)
  }
`;

// Commits a DRAFT row: PENDING plus the sensor/add publish that puts the DSK
// in front of SmartStart. Until this runs the hub has never heard of the unit.
// heldForRemovalOf: the add waits on an old row's unpair and nothing was sent.
export const beginSensorInclusion = /* GraphQL */ `
  mutation BeginSensorInclusion($sensorId: ID!) {
    beginSensorInclusion(sensorId: $sensorId) {
      id
      hubId
      status
      lastReported
      heldForRemovalOf
    }
  }
`;

// Install sign-off. The installer is taken from the caller's Cognito identity
// server-side, so there is nothing to pass and nothing to spoof.
export const completeSensorInstall = /* GraphQL */ `
  mutation CompleteSensorInstall($sensorId: ID!) {
    completeSensorInstall(sensorId: $sensorId) {
      id
      hubId
      status
      lastReported
      installCompletedAt
      installCompletedBy
      installCompletedByName
    }
  }
`;

export const createSensorEvent = /* GraphQL */ `
  mutation CreateSensorEvent($input: CreateSensorEventInput!) {
    createSensorEvent(input: $input) {
      id
      timestamp
      sensorId
      hubId
      eventType
      value
      metadata
    }
  }
`;

export const updateSensorAlertStatus = /* GraphQL */ `
  mutation UpdateSensorAlertStatus($input: UpdateSensorAlertStatusInput!) {
    updateSensorAlertStatus(input: $input) {
      id
      timestamp
      sensorId
      hubId
      alertType
      severity
      message
      value
      metadata
      status
      acknowledgedAt
      acknowledgedBy
      triggeredAt
      firstTriggeredAt
      lastTriggeredAt
      clearedAt
      clearedBy
      clearedByType
      clearedByName
      durationSeconds
    }
  }
`;

export const updateSensorAlertAcknowledgedState = /* GraphQL */ `
  mutation UpdateSensorAlertAcknowledgedState($input: UpdateSensorAlertAcknowledgedStateInput!) {
    updateSensorAlertAcknowledgedState(input: $input) {
      id
      timestamp
      sensorId
      hubId
      alertType
      severity
      message
      value
      metadata
      status
      acknowledgedAt
      acknowledgedBy
      triggeredAt
      firstTriggeredAt
      lastTriggeredAt
      clearedAt
      clearedBy
      clearedByType
      clearedByName
      durationSeconds
    }
  }
`;

export const updateSensorAlertAcknowledgedStateAnonymous = /* GraphQL */ `
  mutation UpdateSensorAlertAcknowledgedStateAnonymous(
    $input: UpdateSensorAlertAcknowledgedStateInput!
  ) {
    updateSensorAlertAcknowledgedStateAnonymous(input: $input) {
      id
      timestamp
      sensorId
      hubId
      alertType
      severity
      message
      value
      metadata
      status
      acknowledgedAt
      acknowledgedBy
      triggeredAt
      firstTriggeredAt
      lastTriggeredAt
      clearedAt
      clearedBy
      clearedByType
      clearedByName
      durationSeconds
    }
  }
`;

export const createServiceRequest = /* GraphQL */ `
  mutation CreateServiceRequest($input: CreateServiceRequestInput!) {
    createServiceRequest(input: $input) {
      id
      customerId
      hubId
      sensorId
      alertId
      jobNumber
      serviceType
      reason
      status
      priority
      requestedAt
      scheduledAt
      completedAt
      createdAt
      updatedAt
      customerComplaint
      customerNotes
      notes
      potentialCause
      accessInstructions
      additionalNotes
      serviceCompanyId
      technicianName
      deviceLocation
      roomType
    }
  }
`;

export const updateServiceRequest = /* GraphQL */ `
  mutation UpdateServiceRequest($input: UpdateServiceRequestInput!) {
    updateServiceRequest(input: $input) {
      id
      customerId
      hubId
      sensorId
      alertId
      jobNumber
      serviceType
      reason
      status
      priority
      requestedAt
      scheduledAt
      completedAt
      createdAt
      updatedAt
      customerComplaint
      customerNotes
      notes
      potentialCause
      accessInstructions
      additionalNotes
      serviceCompanyId
      technicianName
      deviceLocation
      roomType
    }
  }
`;

export const createCustomer = /* GraphQL */ `
  mutation CreateCustomer($input: CreateCustomerInput!) {
    createCustomer(input: $input) {
      id
      name
      email
      phone
      address
      city
      state
      zipCode
      country
      companyName
      createdAt
      updatedAt
    }
  }
`;

export const updateCustomer = /* GraphQL */ `
  mutation UpdateCustomer($input: UpdateCustomerInput!) {
    updateCustomer(input: $input) {
      id
      name
      email
      phone
      address
      city
      state
      zipCode
      country
      companyName
      createdAt
      updatedAt
    }
  }
`;

export const deleteCustomer = /* GraphQL */ `
  mutation DeleteCustomer($id: ID!) {
    deleteCustomer(id: $id) {
      id
      name
      email
      phone
      address
      city
      state
      zipCode
      country
      companyName
      createdAt
      updatedAt
    }
  }
`;

export const createServiceCompany = /* GraphQL */ `
  mutation CreateServiceCompany($input: CreateServiceCompanyInput!) {
    createServiceCompany(input: $input) {
      id
      name
      email
      phone
      address
      city
      state
      zipCode
      logoUrl
      website
      createdAt
      updatedAt
    }
  }
`;

export const updateServiceCompany = /* GraphQL */ `
  mutation UpdateServiceCompany($input: UpdateServiceCompanyInput!) {
    updateServiceCompany(input: $input) {
      id
      name
      email
      phone
      address
      city
      state
      zipCode
      logoUrl
      website
      createdAt
      updatedAt
    }
  }
`;

// HVAC Filter Alert Mutations
export const requestFilterService = /* GraphQL */ `
  mutation RequestFilterService($input: FilterServiceRequestInput!) {
    requestFilterService(input: $input) {
      id
      customerId
      customerName
      serviceCompanyId
      serviceCompanyName
      serviceType
      status
      requestedDate
      scheduledDate
      completedDate
      notes
      sensorId
      hubId
      createdAt
      updatedAt
    }
  }
`;

export const clearHvacFilterAlert = /* GraphQL */ `
  mutation ClearHvacFilterAlert($sensorId: ID!, $hubId: ID!) {
    clearHvacFilterAlert(sensorId: $sensorId, hubId: $hubId)
  }
`;

export const orderFilter = /* GraphQL */ `
  mutation OrderFilter($input: FilterOrderRequestInput!) {
    orderFilter(input: $input) {
      id
      customerId
      customerName
      serviceCompanyId
      serviceCompanyName
      serviceType
      status
      requestedDate
      scheduledDate
      completedDate
      notes
      sensorId
      hubId
      createdAt
      updatedAt
    }
  }
`;

// Power Monitor Alert Mutations
export const requestPowerMonitorService = /* GraphQL */ `
  mutation RequestPowerMonitorService($input: PowerMonitorServiceRequestInput!) {
    requestPowerMonitorService(input: $input) {
      id
      customerId
      customerName
      serviceCompanyId
      serviceCompanyName
      serviceType
      status
      requestedDate
      scheduledDate
      completedDate
      notes
      sensorId
      hubId
      createdAt
      updatedAt
    }
  }
`;

export const clearPowerMonitorAlert = /* GraphQL */ `
  mutation ClearPowerMonitorAlert($sensorId: ID!, $hubId: ID!) {
    clearPowerMonitorAlert(sensorId: $sensorId, hubId: $hubId)
  }
`;

export const requestWaterLeakService = /* GraphQL */ `
  mutation RequestWaterLeakService($input: WaterLeakServiceRequestInput!) {
    requestWaterLeakService(input: $input) {
      id
      customerId
      customerName
      serviceCompanyId
      serviceCompanyName
      serviceType
      status
      requestedDate
      scheduledDate
      completedDate
      notes
      sensorId
      hubId
      createdAt
      updatedAt
    }
  }
`;

export const clearWaterLeakAlert = /* GraphQL */ `
  mutation ClearWaterLeakAlert($sensorId: ID!, $hubId: ID!) {
    clearWaterLeakAlert(sensorId: $sensorId, hubId: $hubId)
  }
`;
export const requestHumidityService = /* GraphQL */ `
  mutation RequestHumidityService($input: HumidityServiceRequestInput!) {
    requestHumidityService(input: $input) {
      id
      customerId
      customerName
      serviceCompanyId
      serviceCompanyName
      serviceType
      reason
      status
      priority
      hubId
      sensorId
      alertId
      notes
      accessInstructions
      deviceLocation
      roomType
      requestedAt
      scheduledAt
      completedAt
      createdAt
      updatedAt
    }
  }
`;

export const clearHumidityAlert = /* GraphQL */ `
  mutation ClearHumidityAlert($sensorId: ID!, $hubId: ID!) {
    clearHumidityAlert(sensorId: $sensorId, hubId: $hubId)
  }
`;

export const requestAirQualityService = /* GraphQL */ `
  mutation RequestAirQualityService($input: AirQualityServiceRequestInput!) {
    requestAirQualityService(input: $input) {
      id
      customerId
      customerName
      serviceCompanyId
      serviceCompanyName
      serviceType
      reason
      status
      priority
      hubId
      sensorId
      alertId
      notes
      accessInstructions
      deviceLocation
      roomType
      requestedAt
      scheduledAt
      completedAt
      createdAt
      updatedAt
    }
  }
`;

export const updateMyNotificationPreferences = /* GraphQL */ `
  mutation UpdateMyNotificationPreferences($input: UpdateUserNotificationPreferencesInput!) {
    updateMyNotificationPreferences(input: $input) {
      userId
      sms {
        enabled
        notifyOnResolve
        water
        power
        hvac
        airQuality
        connectivity
      }
      email {
        enabled
        notifyOnResolve
        water
        power
        hvac
        airQuality
        connectivity
      }
      push {
        enabled
        notifyOnResolve
        water
        power
        hvac
        airQuality
        connectivity
      }
      updatedAt
    }
  }
`;
